(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["build-my-order"] && !Shopify.designMode) return;
  try {
    (function () {
  var cache = {};
  var running = false;
  var added = false;
  var current = [];

  function $(id) { return document.getElementById(id); }

  function h(tag, cls, text) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }

  function money(cents) {
    var cur = ($('bmo-dialog').dataset.currency || 'USD');
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---- OPEN / CLOSE ---- */
  window.openBuildMyOrder = function () {
    $('bmo-overlay').hidden = false;
    $('bmo-dialog').hidden = false;
    document.body.style.overflow = 'hidden';
    if (!$('bmo-input-view').hidden) $('bmo-input').focus();
  };

  window.closeBuildMyOrder = function () {
    $('bmo-overlay').hidden = true;
    $('bmo-dialog').hidden = true;
    document.body.style.overflow = '';
    // The cart page renders its lines server-side, so show what was just added
    if (added && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  };

  document.addEventListener('keydown', function (e) {
    if ($('bmo-dialog').hidden) return;
    if (e.key === 'Escape') closeBuildMyOrder();
    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && !$('bmo-input-view').hidden) buildMyOrder();
  });

  function showInput() {
    $('bmo-input-view').hidden = false;
    $('bmo-result-view').hidden = true;
    $('bmo-foot').hidden = true;
    $('bmo-input').focus();
  }

  window.editBuildMyOrder = function () {
    if (running) return;
    showInput();
  };

  window.clearBuildMyOrder = function () {
    if (running) return;
    $('bmo-input').value = '';
    refreshLive();
    showInput();
  };

  /* ---- PARSE ----
     First value on a line is the part number, a trailing whole number is the quantity,
     anything in between (description) is ignored. Handles tabs, runs of spaces, commas,
     quoted CSV, and "10097 x4". Header rows and blank lines are skipped. Duplicates are summed. */
  function parseList(text) {
    var lines = text.split(/\r?\n/);
    var order = [];
    var byKey = {};

    lines.forEach(function (raw) {
      var line = raw.trim();
      if (!line) return;
      if (/^["']?(part|sku|item)\b/i.test(line) && /\b(qty|quantity|description)\b/i.test(line)) return;

      var m = line.match(/^([^\s,;\t]+)\s*[,;\t]?\s*(.*)$/);
      if (!m) return;
      var sku = m[1].replace(/^[\["']+|[\]"',;]+$/g, '');
      var rest = m[2];
      if (!sku) return;

      var qty = 1;
      var alt = null;
      var q = rest.match(/(?:^|[\s,;x×*])(\d+)\s*$/i) || rest.match(/["'](\d+)["']\s*$/);
      if (q) {
        qty = parseInt(q[1], 10);
      } else if (!rest) {
        // "10097x4" with no gap: try the whole token as a SKU first, then split it
        var g = sku.match(/^(.+?)[x×](\d+)$/i);
        if (g) alt = { sku: g[1], qty: parseInt(g[2], 10) };
      }
      if (!(qty >= 1)) qty = 1;
      if (qty > 9999) qty = 9999;

      var key = sku.toUpperCase();
      if (byKey[key]) {
        byKey[key].qty += qty;
      } else {
        byKey[key] = { sku: sku, qty: qty, alt: alt };
        order.push(byKey[key]);
      }
    });
    return order;
  }

  /* ---- LIVE PREVIEW (as the customer pastes) ---- */
  function refreshLive() {
    var items = parseList($('bmo-input').value);
    var units = items.reduce(function (n, it) { return n + it.qty; }, 0);
    var live = $('bmo-live');
    var label = $('bmo-live-text');
    var btn = $('bmo-build');
    var has = items.length > 0;

    live.classList.toggle('has-parts', has);
    $('bmo-clear').hidden = !$('bmo-input').value;
    btn.disabled = !has || running;
    if (has) {
      label.textContent = items.length + (items.length === 1 ? ' part' : ' parts') + ' · ' + units + (units === 1 ? ' unit' : ' units') + ' ready to build';
      $('bmo-build-label').textContent = 'Build My Order — ' + items.length + (items.length === 1 ? ' part' : ' parts');
    } else {
      label.textContent = 'Or drag a CSV / TXT file onto the box';
      $('bmo-build-label').textContent = 'Build My Order';
    }
  }

  function wireInput() {
    var input = $('bmo-input');
    var drop = $('bmo-drop');
    input.addEventListener('input', refreshLive);

    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', async function (e) {
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!file) return;
      if (!/\.(csv|txt|tsv)$/i.test(file.name) && file.type.indexOf('text/') !== 0) {
        showToast('Please drop a .csv or .txt file');
        return;
      }
      var text = await file.text();
      input.value = input.value ? input.value.replace(/\s+$/, '') + '\n' + text : text;
      refreshLive();
    });
    refreshLive();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireInput);
  else wireInput();

  /* ---- LOOKUP ----
     Predictive Search finds candidate products, then each product's .js gives the real
     variants so we can match the SKU exactly. */
  async function findVariant(sku) {
    var key = sku.toUpperCase();
    if (key in cache) return cache[key];

    var url = '/search/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=variants.sku,title';
    var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('lookup');
    var data = await res.json();
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    // Products whose title carries "[SKU]" are the likeliest match, check them first
    var tag = '[' + key + ']';
    products.sort(function (a, b) {
      return (b.title.toUpperCase().indexOf(tag) > -1) - (a.title.toUpperCase().indexOf(tag) > -1);
    });

    var found = null;
    for (var i = 0; i < products.length && !found; i++) {
      var pr = await fetch('/products/' + products[i].handle + '.js');
      if (!pr.ok) continue;
      var product = await pr.json();
      for (var j = 0; j < product.variants.length; j++) {
        if ((product.variants[j].sku || '').toUpperCase() === key) {
          found = {
            variant: product.variants[j],
            title: product.title,
            url: product.url || '/products/' + product.handle,
            image: product.featured_image || null,
            plan: preorderPlan(product)
          };
          break;
        }
      }
    }
    if (found) found.inStock = await stockFor(found);
    cache[key] = found;
    return found;
  }

  // true / false from the store's own inventory rule, or null if it can't be read
  async function stockFor(found) {
    try {
      // No Accept: application/json here, Shopify would then return the product's own JSON
      // instead of this view
      var res = await fetch(found.url + '?view=build-my-order');
      if (!res.ok) return null;
      var data = JSON.parse(await res.text());
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === found.variant.id) return !!data.variants[i].in_stock;
      }
    } catch (e) {}
    return null;
  }

  // Out-of-stock parts sell through a "Preorder" selling plan (STOQ); other plans are ignored
  function preorderPlan(product) {
    var groups = product.selling_plan_groups || [];
    for (var i = 0; i < groups.length; i++) {
      var plans = groups[i].selling_plans || [];
      for (var j = 0; j < plans.length; j++) {
        if (/pre-?order/i.test(groups[i].name || '') || /pre-?order/i.test(plans[j].name || '')) return plans[j].id;
      }
    }
    return null;
  }

  async function addLine(variantId, qty, plan) {
    var body = { id: variantId, quantity: qty };
    if (plan) body.selling_plan = plan;
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (res.ok) return { ok: true };
    var err = {};
    try { err = await res.json(); } catch (e) {}
    return { ok: false, message: err.description || err.message || 'Could not add' };
  }

  function cleanTitle(title) {
    return title.replace(/^\s*\[[^\]]*\]\s*-?\s*/, '');
  }

  /* ---- ROWS ---- */
  var ICON_BOX = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>';
  var ICON_OK = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_WARN = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="7" x2="12" y2="13"/><line x1="12" y1="17" x2="12" y2="17.01"/></svg>';
  var ICON_X = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var ICON_SPIN = '<span class="bmo-spin"></span>';

  function makeRow(item, index) {
    var el = h('div', 'bmo-row is-wait');
    el.style.animationDelay = Math.min(index, 12) * 40 + 'ms';
    var thumb = h('span', 'bmo-thumb');
    thumb.innerHTML = ICON_BOX;
    var main = h('div', 'bmo-row-main');
    var sku = h('span', 'bmo-sku', item.sku);
    var qty = h('span', 'bmo-qty', '×' + item.qty);
    var name = h('span', 'bmo-name', 'Looking up…');
    main.appendChild(sku);
    main.appendChild(qty);
    main.appendChild(name);
    var end = h('div', 'bmo-row-end');
    var price = h('span', 'bmo-price');
    var status = h('span', 'bmo-status is-wait');
    status.innerHTML = ICON_SPIN;
    end.appendChild(price);
    end.appendChild(status);
    el.appendChild(thumb);
    el.appendChild(main);
    el.appendChild(end);
    return { el: el, thumb: thumb, name: name, price: price, status: status, sku: sku, qty: qty, state: 'wait', match: null, qtyN: item.qty, btn: null };
  }

  function setStatus(r, cls, text, link) {
    r.status.className = 'bmo-status ' + cls;
    r.status.textContent = '';
    if (cls === 'is-ok' || text === 'Preorder added') {
      var tick = h('span');
      tick.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      r.status.appendChild(tick);
    }
    if (link) {
      var a = h('a', null, text);
      a.href = link;
      r.status.appendChild(a);
    } else {
      r.status.appendChild(document.createTextNode(text));
    }
  }

  function setBanner(kind, title, sub, icon) {
    var b = $('bmo-banner');
    b.className = 'bmo-banner' + (kind ? ' is-' + kind : '');
    $('bmo-banner-icon').innerHTML = icon;
    $('bmo-banner-title').textContent = title;
    $('bmo-banner-sub').textContent = sub;
  }

  function setProgress(done, total) {
    $('bmo-progress-bar').style.width = Math.round((done / total) * 100) + '%';
  }

  /* ---- BUILD ---- */
  window.buildMyOrder = async function () {
    if (running) return;
    var items = parseList($('bmo-input').value);
    if (!items.length) {
      showToast('Paste at least one part number');
      return;
    }

    running = true;
    $('bmo-build').disabled = true;
    $('bmo-input-view').hidden = true;
    $('bmo-result-view').hidden = false;
    $('bmo-actions').hidden = true;
    $('bmo-foot').hidden = true;
    $('bmo-progress').classList.remove('is-done');
    var results = $('bmo-results');
    results.textContent = '';
    setProgress(0, 1);
    setBanner('', 'Building your order…', 'Matching ' + items.length + (items.length === 1 ? ' part number' : ' part numbers'), ICON_SPIN);

    var rows = items.map(function (it, i) {
      var r = makeRow(it, i);
      results.appendChild(r.el);
      return r;
    });
    current = rows;
    $('bmo-note').hidden = true;
    $('bmo-add-pre').hidden = true;

    var total = items.length * 2;
    var done = 0;
    var matches = new Array(items.length);
    var next = 0;

    // Phase 1: look every line up, a few at a time
    async function worker() {
      while (next < items.length) {
        var i = next++;
        try {
          var m = await findVariant(items[i].sku);
          if (!m && items[i].alt) {
            var altMatch = await findVariant(items[i].alt.sku);
            if (altMatch) {
              items[i].sku = items[i].alt.sku;
              items[i].qty = items[i].alt.qty;
              rows[i].sku.textContent = items[i].sku;
              rows[i].qty.textContent = '×' + items[i].qty;
              m = altMatch;
            }
          }
          matches[i] = m || null;
        } catch (e) {
          matches[i] = 'error';
        }
        var r = rows[i];
        if (matches[i] && matches[i] !== 'error') {
          r.name.textContent = cleanTitle(matches[i].title);
          if (matches[i].image) {
            var img = matches[i].image;
            r.thumb.innerHTML = '';
            r.thumb.style.backgroundImage = 'url("' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=96")';
          }
        }
        setProgress(++done, total);
      }
    }
    await Promise.all([worker(), worker(), worker(), worker()]);

    // Phase 2: add to the cart in order. A plain add that is refused for a part that has a
    // Preorder plan means it is out of stock, so offer it as a preorder instead of failing.
    for (var i = 0; i < items.length; i++) {
      var m = matches[i];
      var r = rows[i];
      r.qtyN = items[i].qty;
      if (m === 'error') {
        r.state = 'bad';
        r.name.textContent = 'Could not check this part';
        setStatus(r, 'is-bad', 'Lookup failed, try again');
        r.el.classList.add('is-bad');
      } else if (!m) {
        r.state = 'bad';
        r.name.textContent = 'No part with this number';
        setStatus(r, 'is-bad', 'Not found');
        r.el.classList.add('is-bad');
      } else {
        r.match = m;
        // Out of stock with a Preorder plan: never add silently, let the customer choose
        var out = (m.inStock === false && m.plan) ? { ok: false, offer: true } : await addLine(m.variant.id, r.qtyN);
        if (out.ok) {
          markAdded(r, false);
        } else if (m.plan) {
          markOffer(r);
        } else {
          r.state = 'bad';
          setStatus(r, 'is-bad', out.message + ' – view part', m.url);
          r.el.classList.add('is-bad');
        }
      }
      r.el.classList.remove('is-wait');
      setProgress(++done, total);
    }

    // Lines that need attention first (not found, failed, preorder offers)
    rows.filter(function (r) { return r.state !== 'ok'; }).reverse().forEach(function (r) {
      results.insertBefore(r.el, results.firstChild);
    });

    $('bmo-progress').classList.add('is-done');
    $('bmo-actions').hidden = false;
    await refreshSummary();

    running = false;
    refreshLive();
  };

  /* ---- ROW STATES + SUMMARY ---- */
  function markAdded(r, preorder) {
    added = true;
    r.state = preorder ? 'pre-added' : 'ok';
    r.el.classList.remove('is-pre', 'is-bad');
    if (r.btn) { r.btn.remove(); r.btn = null; }
    r.price.textContent = money(r.match.variant.price * r.qtyN);
    setStatus(r, preorder ? 'is-pre' : 'is-ok', preorder ? 'Preorder added' : 'Added');
  }

  function markOffer(r) {
    r.state = 'offer';
    r.el.classList.add('is-pre');
    r.price.textContent = money(r.match.variant.price * r.qtyN);
    setStatus(r, 'is-pre', 'Out of stock · 10–13 week lead time');
    var pre = h('button', 'bmo-pre-btn', 'Preorder');
    pre.type = 'button';
    pre.addEventListener('click', async function () {
      await addPreorder(r);
      await refreshSummary();
    });
    var skip = h('button', 'bmo-skip-btn', 'Skip');
    skip.type = 'button';
    skip.addEventListener('click', async function () {
      markSkipped(r);
      await refreshSummary();
    });
    r.btn = h('div', 'bmo-pre-actions');
    r.btn.appendChild(pre);
    r.btn.appendChild(skip);
    r.status.parentNode.appendChild(r.btn);
  }

  function markSkipped(r) {
    r.state = 'skipped';
    r.el.classList.remove('is-pre');
    r.el.classList.add('is-skipped');
    if (r.btn) { r.btn.remove(); r.btn = null; }
    r.price.textContent = '';
    setStatus(r, 'is-wait', 'Skipped, not in your order');
  }

  async function addPreorder(r) {
    if (r.state !== 'offer') return;
    var btns = r.btn ? r.btn.querySelectorAll('button') : [];
    btns.forEach(function (b) { b.disabled = true; });
    var out = await addLine(r.match.variant.id, r.qtyN, r.match.plan);
    if (out.ok) {
      markAdded(r, true);
    } else {
      btns.forEach(function (b) { b.disabled = false; });
      showToast(out.message || 'Could not add this preorder');
    }
  }

  window.addAllPreorders = async function () {
    if (running) return;
    running = true;
    var pending = current.filter(function (r) { return r.state === 'offer'; });
    for (var i = 0; i < pending.length; i++) await addPreorder(pending[i]);
    await refreshSummary();
    running = false;
  };

  async function refreshSummary() {
    var n = current.filter(function (r) { return r.state !== 'skipped'; }).length;
    var count = function (s) { return current.filter(function (r) { return r.state === s; }).length; };
    var ok = count('ok');
    var pre = count('pre-added');
    var offer = count('offer');
    var bad = count('bad');
    var added = ok + pre;
    var units = current.reduce(function (t, r) { return t + (r.state === 'ok' || r.state === 'pre-added' ? r.qtyN : 0); }, 0);
    var parts = n + (n === 1 ? ' part' : ' parts');

    if (!offer && !bad) {
      setBanner('ok', 'All ' + parts + ' added',
        pre ? pre + (pre === 1 ? ' is a preorder' : ' are preorders') + ' (10–13 week lead time). The rest is ready to check out.'
            : units + (units === 1 ? ' unit is' : ' units are') + ' in your cart, ready to check out.', ICON_OK);
    } else if (added || offer) {
      var bits = [];
      if (offer) bits.push(offer + (offer === 1 ? ' part is' : ' parts are') + ' out of stock. Preorder or skip');
      if (bad) bits.push(bad + (bad === 1 ? ' line needs' : ' lines need') + ' your attention');
      setBanner('partial', added ? added + ' of ' + parts + ' added' : 'Nothing added yet', bits.join(' · ') + ' (shown first).', ICON_WARN);
    } else {
      setBanner('none', 'Nothing could be added', 'Check the part numbers below and try again.', ICON_X);
    }

    $('bmo-note').hidden = !(offer || pre);
    var addAll = $('bmo-add-pre');
    addAll.hidden = offer === 0;
    addAll.textContent = offer > 1 ? 'Add all ' + offer + ' preorders' : 'Add preorder';

    try {
      var cart = await (typeof updateCartCount === 'function' ? updateCartCount() : fetch('/cart.js').then(function (x) { return x.json(); }));
      if (cart && added) {
        $('bmo-foot-total').textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' · ' + money(cart.total_price);
        $('bmo-foot').hidden = false;
      }
    } catch (e) {}
  }
})();
  } catch(e) { console.error(e); }
})();

})();
